import { Api } from './Api';

export class Dashboard {
  static getDashboardInfo = <T>() => Api.get<T>('dashboard/main/');
  static getMachines = <T>() => Api.get<T>('dashboard/machines/');
  static activateMachine(body: any): ReturnType<typeof Api.post> {
    return Api.post(`dashboard/machines/${body.id}/`, {
      machine_id: body.machineId,
    });
  }
  static deactivateMachine(id: number): ReturnType<typeof Api.delete> {
    return Api.delete(`dashboard/machines/${id}/`);
  }
  static renameMachine(payload: { id: number; nickname: string }): ReturnType<typeof Api.patch> {
    return Api.patch(`dashboard/machines/${payload.id}/`, { nickname: payload.nickname });
  }
  static getOwnerInfo = <T>() => Api.get<T>('dashboard/licenses/');
}
